import { MouseEventHandler } from 'react';

import { PastSearchesHeader } from './PastSearchesHeader';
import NormalSearchList from '../Lists/NormalSearchList';
import { BookerSearchViewModel } from '../../../BookerSearchViewModel';

type Props = {
  searchText: string;
  onClearClick?: MouseEventHandler<HTMLButtonElement> | undefined;
  history?: BookerSearchViewModel[];
  onChange: (item?: BookerSearchViewModel) => void;
  callBack?: (item: BookerSearchViewModel) => void;
  onRemoveItem?: (item: BookerSearchViewModel) => void;
  inputLocation?: string;
};

const PastSearchesList = ({
  searchText,
  inputLocation,
  history = [],
  onClearClick,
  onChange,
  callBack,
  onRemoveItem,
}: Props) => {
  return (
    <>
      <PastSearchesHeader onClearClick={onClearClick} />

      <NormalSearchList
        searchText={searchText}
        data={history.slice(0, 3)}
        onChange={onChange}
        callBack={callBack}
        showRemoveButton={true}
        onRemoveItem={onRemoveItem}
        inputLocation={inputLocation}
      />
    </>
  );
};

export default PastSearchesList;
